export default "__VITE_ASSET__4200155e__"